//主要定义一些常量变量
import pkg from '@/../package.json'
export const APP_NAME = pkg.name

export const REPORT_MIN_DATE = new Date(2023, 6, 1)
